import React from 'react'
import PropTypes from 'prop-types'
import { DivImages, DivSkillsTitle, ChildGridContainer } from './styles'
import ImageSkill from './image-skill/ImageSkill'
import { generateID } from '../../../../modules/generator-id/generator-id'
import TextTitle from '../../../infoAboutMe/title-h3/TextTitle'

export const SkillsCategory = ({ category, arrayUrls, rigth, stylesContainer }) => {

  return (
    <ChildGridContainer
      data-testid="skills-area"
      {...stylesContainer}
    >
      
      <DivSkillsTitle>
        
        <TextTitle 
          text={category}
          stylesElement={{
            color: "#41C7C7",
            fontSize_lg: "2.5rem",
            fontSize: "1.6rem",
            marginTop: "10px",
            marginBottom: "10px",
            paddingBottom_lg: "10px",
            textAlign: "center", 
          }}
        />
          
      </DivSkillsTitle>

      <DivImages>
        {
          arrayUrls.map(skill => 
            <ImageSkill
              url={skill}
              key={generateID()}
              altText={category}
            />
      
          )
        }
      </DivImages>

    </ChildGridContainer>
  )
}


SkillsCategory.propTypes = {
  category: PropTypes.string.isRequired,
  arrayUrls: PropTypes.array.isRequired,
}

